import { render, staticRenderFns } from "./SLPayments.vue?vue&type=template&id=22f648a8&"
import script from "./SLPayments.vue?vue&type=script&lang=js&"
export * from "./SLPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports